export default "__VITE_ASSET__401cb06f__"